import { constants } from "@newsela/angelou";
import type { CSSObject } from "@emotion/react";

const { colors } = constants;
const white = colors.ui.white[500];
const darkBlue = colors.ui.core[700];

export const wrapperCSS = {
  display: "flex",
  alignItems: "center",
  color: darkBlue,
  fontWeight: "bold",
  minWidth: "141px",
  padding: "0px 18px",
  backgroundColor: white,
  boxShadow: "0px -3px 10px rgba(0, 0, 0, 0.25)",
  height: "64px",
  borderRadius: "8px",
  justifyContent: "center",
  "div:first-of-type": {
    borderRadius: "8px",
  },
  "div:last-of-type": {
    borderRadius: "8px",
  },
};

const triangleBaseCss: CSSObject = {
  width: 0,
  height: 0,
  borderLeft: "10px solid transparent",
  borderRight: "10px solid transparent",
  borderBottom: `10px solid ${white}`,
  position: "absolute",
};

export const triangleCss: CSSObject = {
  ...triangleBaseCss,
  bottom: "-10px",
  transform: "rotate(180deg)",
};

export const triangleCssMobile: CSSObject = {
  ...triangleBaseCss,
  top: "-9px",
  transform: "rotate(360deg)",
};

export const rootCss = (isVisible: boolean): CSSObject => ({
  display: isVisible ? "flex" : "none",
  width: "141px",
  height: "64px",
  justifyContent: "center",
  alignItems: "center",
  position: "absolute",
  backgroundColor: white,
  ":hover": {
    textDecoration: "underline",
    cursor: "pointer",
  },
});

export const buttonCss = (isTextSelected: boolean): CSSObject => {
  return {
    // Prevents the button from being focusable or accessible to screen readers when it is not visible.
    display: isTextSelected ? "flex" : "none",
    alignItems: "center",
    color: darkBlue,
    fontWeight: "bold",
    width: "141px",
    height: "64px",
  };
};

export const annotateIconCss: CSSObject = {
  marginRight: "7px",
  width: "17px",
  path: {
    stroke: darkBlue,
    strokeWidth: "3px",
  },
};
